import { render } from "./ViewReservations.vue?vue&type=template&id=10b16136"
import script from "./ViewReservations.vue?vue&type=script&lang=js"
export * from "./ViewReservations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__